import { Injectable } from '@angular/core';
// import html2canvas from 'html2canvas';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../../app.constants';
import { AuthService } from '../auth/auth.service';
import { ToastService } from '../toast.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
declare var window: any;
declare var html2canvas: any;

@Injectable()
export class DownloadService {

  constructor(private _http: HttpClient,
    private config: Configuration,
    private authService: AuthService,
    private toastService: ToastService) { }

  downloadPng(fileName, elementId, supplier, manufacture, graphData) {

    if (fileName === 'businessCard') {
      document.getElementById('profile').remove();
      document.getElementById('export').remove();
      document.getElementById('close').remove();
    }
    html2canvas(document.getElementById(elementId), {
      scrollY: -window.scrollY
    }).then(canvas => {
      var canvasElement = canvas;
      var MIME_TYPE = "image/png";
      var imgURL = canvasElement.toDataURL(MIME_TYPE);

      var doc = new jsPDF();

      doc.setFontSize(14);
      doc.setFont('courier');
      const imgProps = doc.getImageProperties(imgURL);
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(imgURL,
        "png", 2, 12, pdfWidth, pdfHeight);

      doc.text(20, 12 + pdfHeight + 5, 'Manufacturer : ');
      doc.setFontType('italic');
      let manufactureDivided = this.chunkArray(manufacture, 8);
      console.log(manufactureDivided);
      let yaxis = 12 + pdfHeight + 10;
      for (let index = 0; index < manufactureDivided.length; index++) {
        const element = manufactureDivided[index];
        // element.forEach(element => {
        doc.text(20, yaxis, element.join(','));
        yaxis += 5;
        // });
      }
      yaxis += 8;
      doc.setFontType('normal');
      doc.text(20, yaxis, 'Suppliers : ');
      doc.setFontType('italic');
      let supplierDivided = this.chunkArray(supplier, 8);
      console.log(supplierDivided);

      for (let index = 0; index < supplierDivided.length; index++) {
        const element = supplierDivided[index];
        // element.forEach(element => {
        yaxis += 5;
        doc.text(20, yaxis, element.join(','));

        // });
      }
      var col = ["Name", "No Of Products"];
      var rows = [];
      /* The following array of object as response from the API req  */
      graphData.forEach(element => {
        var temp = [element.name, element.y];
        rows.push(temp);

      });
      if (graphData.length > 0) {
        doc.autoTable(col, rows, { startY: yaxis + 10 });
      }


      // if(manufacture.length>0)
      // {
      //   doc.text(53, 150, manufacture.length>2?(manufacture[0]+','+manufacture[1]+` and ${manufacture.length-2} more`):(manufacture.length>1?(manufacture[0]+','+manufacture[1]):manufacture[0]));

      // }
      // if(supplier.length>0)
      // {
      //   doc.text(53, 160, supplier.length>2?(supplier[0]+','+supplier[1]+` and ${supplier.length-2} more`):(supplier.length>1?(supplier[0]+','+supplier[1]):supplier[0]));

      // }
      // doc.text(20, 160, 'Suppliers : ');

      doc.save('download.pdf');
      // var dlLink = document.createElement('a');
      // dlLink.download = fileName;
      // dlLink.href = imgURL;
      // dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');
      // document.body.appendChild(dlLink);
      // dlLink.click();
      // document.body.removeChild(dlLink);
    }, err => {
      console.log(err)
    });
  }
  downloadPngAll(fileName, elementId, supplier, manufacture, bySupplier, byCountry, top20) {

    if (fileName === 'businessCard') {
      document.getElementById('profile').remove();
      document.getElementById('export').remove();
      document.getElementById('close').remove();
    }
    html2canvas(document.getElementById(elementId), {
      scrollY: -window.scrollY
    }).then(canvas => {
      var canvasElement = canvas;
      var MIME_TYPE = "image/png";
      var imgURL = canvasElement.toDataURL(MIME_TYPE);

      var doc = new jsPDF();

      doc.setFontSize(14);
      doc.setFont('courier');
      const imgProps = doc.getImageProperties(imgURL);
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(imgURL,
        "png", 2, 12, pdfWidth, pdfHeight);

      doc.text(20, 12 + pdfHeight + 5, 'Manufacturer : ');
      doc.setFontType('italic');
      let manufactureDivided = this.chunkArray(manufacture, 8);
      console.log(manufactureDivided);
      let yaxis = 12 + pdfHeight + 10;
      for (let index = 0; index < manufactureDivided.length; index++) {
        const element = manufactureDivided[index];
        // element.forEach(element => {
        doc.text(20, yaxis, element.join(','));
        yaxis += 5;
        // });
      }
      yaxis += 8;
      doc.setFontType('normal');
      doc.text(20, yaxis, 'Suppliers : ');
      doc.setFontType('italic');
      let supplierDivided = this.chunkArray(supplier, 8);
      console.log(supplierDivided);

      for (let index = 0; index < supplierDivided.length; index++) {
        const element = supplierDivided[index];
        // element.forEach(element => {
        yaxis += 5;
        doc.text(20, yaxis, element.join(','));

        // });
      }


      var col = ["Name", "No Of Products By Supplier"];

      var rows = [];

      /* The following array of object as response from the API req  */
      bySupplier.forEach(element => {
        var temp = [element.name, element.y];
        rows.push(temp);

      });
      if (bySupplier.length > 0) {
        doc.autoTable(col, rows, { startY: yaxis + 10 });
      }

      var colCountry = ["Name", "No Of Products By Country"];

      var rowsCountry = [];

      /* The following array of object as response from the API req  */




      // yaxis=yaxis+(bySupplier.length*1);

      byCountry.forEach(element => {
        var temp = [element.name, element.y];
        rowsCountry.push(temp);

      });
      if (byCountry.length > 0) {
        doc.autoTable(colCountry, rowsCountry);
      }

      var colTop20 = ["Name", "Top 20 Supplier Product Categories"];

      var rowstop20 = [];

      /* The following array of object as response from the API req  */




      // yaxis=yaxis+(byCountry.length*1);

      top20.forEach(element => {
        var temp = [element.name, element.y];
        rowstop20.push(temp);

      });
      if (top20.length > 0) {
        doc.autoTable(colTop20, rowstop20);
      }
      // if(manufacture.length>0)
      // {
      //   doc.text(53, 150, manufacture.length>2?(manufacture[0]+','+manufacture[1]+` and ${manufacture.length-2} more`):(manufacture.length>1?(manufacture[0]+','+manufacture[1]):manufacture[0]));

      // }
      // if(supplier.length>0)
      // {
      //   doc.text(53, 160, supplier.length>2?(supplier[0]+','+supplier[1]+` and ${supplier.length-2} more`):(supplier.length>1?(supplier[0]+','+supplier[1]):supplier[0]));

      // }
      // doc.text(20, 160, 'Suppliers : ');

      doc.save('download.pdf');
      // var dlLink = document.createElement('a');
      // dlLink.download = fileName;
      // dlLink.href = imgURL;
      // dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');
      // document.body.appendChild(dlLink);
      // dlLink.click();
      // document.body.removeChild(dlLink);
    }, err => {
      console.log(err)
    });
  }

  downloadExcel(fileName, MIME_TYPE, url) {
    if (window.cordova) {
      window.open(url, '_system');
    } else {
      const dlLink = document.createElement('a');
      dlLink.download = fileName;
      dlLink.href = url;
      dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');
      document.body.appendChild(dlLink);
      dlLink.click();
      document.body.removeChild(dlLink);
    }
  }

  public shareReportInEmail(fileName, elementId, recieverEmail, emailText) {
    console.log(fileName, elementId, recieverEmail, emailText);
    html2canvas(document.getElementById(elementId)).then(canvas => {
      var canvasElement = canvas;
      var MIME_TYPE = 'image/png';
      var imgURL = canvasElement.toDataURL(MIME_TYPE);
      var dlLink = document.createElement('a');
      dlLink.download = fileName;
      dlLink.href = imgURL;
      dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');
      return this._http.post(`${this.config.ServerApiUrl}/associate/shareReport`, {
        'emailAttachment': dlLink.href,
        'email': recieverEmail, 'emailText': emailText
      }).subscribe((data) => {
        this.toastService.success();
      }, (error) => {
        this.toastService.error('Email not sent');

      });
    }).catch(error => {
      console.log(error)
    });
  }
  chunkArray(myArray, chunk_size) {
    var index = 0;
    var arrayLength = myArray.length;
    var tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
      let myChunk = myArray.slice(index, index + chunk_size);
      // Do something if you want with the group
      tempArray.push(myChunk);
    }

    return tempArray;
  }
}
